import React from "react";
import { useSiteSettings } from "../lib/hooks";
import { buildWhatsAppLink } from "../lib/format";
import { MessageCircle } from "lucide-react";

const WhatsAppFloat = ({ vehicle }) => {
  const s = useSiteSettings();
  if (!s?.whatsapp) return null;
  const number = s.whatsapp;
  let message = "Hi Autobahn Cars, I'd like more information about your vehicles.";
  if (vehicle) {
    const url = typeof window !== "undefined" ? window.location.href : "";
    message = `Hi Autobahn Cars, I'm interested in the ${vehicle.manufacturing_year} ${vehicle.brand} ${vehicle.model} ${vehicle.variant || ""}. Link: ${url}`;
  }
  const href = buildWhatsAppLink(number, message);
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 left-6 z-30 bg-[#25D366] hover:bg-[#1ea855] transition-colors text-white h-14 w-14 rounded-full flex items-center justify-center shadow-lg"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-float"
    >
      <MessageCircle size={26} />
    </a>
  );
};

export default WhatsAppFloat;
